import React from 'react';
import { FaqItem } from '../FaqItem';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/content';
export function FaqSection() {
  return <section id="faq" className="bg-brand-mist px-5 py-14 sm:py-20" data-id="element-49" data-mp="2kxficgk4xeo8">
      <div className="mx-auto max-w-3xl" data-id="element-50" data-mp="2kyqogn11yyii">
        <SectionHeading title="Frequently Asked Questions" data-id="element-51" data-mp="2fym7kvw8g1rr" />
        <div className="mt-10 space-y-3" data-id="element-52" data-mp="2g0fd27v40fy6">
          {faqs.map(faq => <FaqItem key={faq.question} {...faq} data-id="element-53" data-mp="2twstrertkdbl" />)}
        </div>
      </div>
    </section>;
}